export function fetchAddonsVPS(pid) {
	return fetch(
		`${process.env.REACT_APP_BASE_API}order/apis/getAddonsVPS.php?pid=` + pid,
	).then((response) => response.json())
}

export function fetchProductsPromoVPS(data) {
	return fetch(
		`${process.env.REACT_APP_BASE_API}order/apis/getProductsPromo.php?gid=` + data.gid + '&pid=' + data.pid + '&billingcycle=' + data.billingcycle + '&promocode=' + data.promocode + '&userid=' + data.userid
	).then((response) => response.json())
}
